import Vue from 'vue'

export default {
  getVerification: function () {
    let apiDetailPath = '/verifications'
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.token.idToken} })
  },
  getVerificationLiveSnapshot: function () {
    let apiDetailPath = '/verifications/live'
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.token.idToken} })
  },
  getVerificationLiveSnapshotUrlV2: function () {
    let apiDetailPath = '/verifications/snapshot_url'
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.token.idToken} })
  },
  getVerificationLiveSnapshotV2: function (snapshotUrl, token) {
    let fullUrl = snapshotUrl + '?duration=10&interval=0'
    return Vue.http.get(fullUrl, { headers: {'Authorization': 'Bearer ' + token} })
  },
  getVerificationEvent: function () {
    let apiDetailPath = '/verifications/event'
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.token.idToken} })
  },
  getVerificationPrivacyStatus: function () {
    let apiDetailPath = '/verifications/privacy/status'
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.token.idToken} })
  },
  createVerificationResponse: function (isCrime) {
    let apiDetailPath = '/verifications/response'
    let data = {
      type: isCrime ? 1 : 2
    }
    return Vue.http.post(Vue.env.apiPath + apiDetailPath, data, { headers: {'Authorization': 'Bearer ' + Vue.token.idToken} })
  },
  setPrivacyDisabledDuration: function (durationSec) {
    let apiDetailPath = '/verifications/privacy.duration'
    let data = {
      privacy_disabled_duration: durationSec > 86400 ? 86400 : durationSec < 0 ? 0 : durationSec
    }
    return Vue.http.post(Vue.env.apiPath + apiDetailPath, data, { headers: {'Authorization': 'Bearer ' + Vue.token.idToken} })
  },
  getSiteVerificationDuration: function () {
    let apiDetailPath = '/verifications/configure'
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.token.idToken} })
  }
}



// WEBPACK FOOTER //
// ./src/apis/verification.js